export default {
    id:0,
    text: '',
    invoice_id:'',
    cashier_id:'',
    cashier_name:'',
    date:''
}
